<template>
  <div class="Background">

    <div class="link_location">
      <h2 class="Title">
        설정 <v-icon small class="mdi mdi-chevron-right" />
        시스템 설정 <v-icon small class="mdi mdi-chevron-right" />
        <!-- <a href="/cdn">배포</a> -->
        <span style="color: rgb(29, 120, 211); font-weight: bold;">배포</span>
      </h2>
    </div>

    <!-- <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        배포
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템관리 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/cdn">배포</a>
      </div>

    </div> -->


    <v-row>
      <v-col cols="5">
        <SearchTextfield :search="searchQuery" placeholder="검색" />
      </v-col>
      <v-col class="text-right mb-2">
        <IconButton icon="mdi mdi-autorenew" x-small @click="refresh" class="mr-2" small />

        <TextButton :buttonText="$store.getters.t('활성화')" class="mr-2"
          :disabled="selected.length === 0 || selected.some(item => item.status === 'Enabled')"
          @click="cdnStatusOnChange" />

        <TextButton :buttonText="$store.getters.t('비활성화')" class="mr-2"
          :disabled="selected.length === 0 || selected.some(item => item.status === 'Disabled')"
          @click="cdnStatusOffChange" />

        <IconButton icon="mdi-trash-can-outline"
          :disabled="selected.length === 0 || selected.some(item => item.status === 'Enabled')" @click="cdnDelete"
          small />
      </v-col>
    </v-row>

    <!--table card-->
    <v-data-table :headers="headers" :items="cdnItem" :items-per-page="10"
      :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" :loading="loading"
      :no-data-text="'데이터 없습니다'" :key="cdnItem.id" class="data-table" :disable-sort="true" show-select
      :search="searchQuery" v-model="selected">

      <template v-slot:item.cdn_cname="{ item }">
        <div v-if="item.cdn_type === 'Tencent'">
          {{ item.domain }}
        </div>
        <div v-else>
          {{ item.cdn_cname }}
        </div>
      </template>

      <template v-slot:item.domain="{ item }">
        <v-card v-if="item.cdn_type === 'Tencent'" small link outlined color="#eee" class="pa-2 pt-1 pb-1"
          style="max-width: fit-content;">
          {{ item.cdn_cname.length > 20 ? item.cdn_cname.slice(0, 20) + '...' : item.cdn_cname }}
          <!-- {{ item.cdn_cname }} -->
        </v-card>
        <v-card v-else small link outlined color="#eee" class="pa-2 pt-1 pb-1" style="max-width: fit-content;">
          {{ item.domain.length > 20 ? item.domain.slice(0, 20) + '...' : item.domain }}
          <!-- {{ item.domain }} -->
        </v-card>
      </template>

      <template v-slot:item.status="{ item }">
        <div v-if="item.status === 'Enabled'" style="color: #388E3C;" class="status-container">
          <v-icon class="status-icon mdi mdi-check-circle-outline mr-1" small color="#388E3C"></v-icon><b
            class="status-text">{{ item.status }}</b>
        </div>
        <div v-else-if="item.status === 'Disabled'" style="color: #989898;" class="status-container">
          <v-icon class="status-icon mdi mdi-dots-horizontal-circle-outline mr-1" small color="#989898"></v-icon><b
            class="status-text">{{ item.status }}</b>
        </div>
        <div v-else-if="item.status === 'processing'" style="color: #989898;" class="status-container">
          <v-icon class="status-icon mdi mdi-clock-outline mr-1" small color="#ff9e2f"></v-icon><b class="status-text"
            style="color: #989898; font-style: italic;">Deploying</b><!-- <b class="status-text" style="color: #989898; font-style: italic;">InProgress</b> -->
        </div>
        <div v-else-if="item.status === 'closing'" style="color: #989898;" class="status-container">
          <v-icon class="status-icon mdi mdi-clock-outline mr-1" small color="#989898"></v-icon><b class="status-text"
            style="color: #989898; font-style: italic;">Disabling</b>
        </div>
      </template>

      <template v-slot:item.cdn_status="{ item }">
        <div v-if="item.cdn_status === 'Enabled'" style="color: #388E3C;" class="status-container">
          <v-icon class="status-icon mdi mdi-check-circle-outline mr-1" small color="#388E3C"></v-icon><b
            class="status-text">{{ item.cdn_status }}</b>
        </div>
        <div v-else-if="item.cdn_status === 'Disabled'" style="color: #989898;" class="status-container">
          <v-icon class="status-icon mdi mdi-dots-horizontal-circle-outline mr-1" small color="#989898"></v-icon><b
            class="status-text">{{ item.cdn_status }}</b>
        </div>
      </template>

      <template v-slot:item.cdn_deploy="{ item }">

        <div v-if="item.cdn_deploy === 'processing'">
          <v-icon class="status-icon mdi mdi-clock-outline mr-1" small color="#ff9e2f"></v-icon><b class="status-text"
            style="color: #989898; font-style: italic;">Deploying</b>
        </div>
        <div v-else-if="item.cdn_deploy === 'disabling'">
          <v-icon class="status-icon mdi mdi-clock-outline mr-1" small color="#989898"></v-icon><b class="status-text"
            style="color: #989898; font-style: italic;">Disabling</b>
        </div>
        <div v-else>
          <v-icon class="status-icon" style="color: #388E3C;" small>
            {{ item.cdn_deploy === 'Deployed' ? 'mdi mdi -dots - horizontal - circle - outline' : '' }}</v-icon>
          <b class="status-text" style="color: #388E3C;">{{ item.cdn_deploy }}</b>
        </div>

      </template>

      <template v-slot:item.cdn_type="{ item }">
        <!-- <div v-if="item.cdn_type === 'a'">
          {{ 'cloudfront' }}
        </div>
        <div v-else-if="item.cdn_type === 'h'">
          {{ '효성 CDN' }}
        </div>
        <div v-else-if="item.cdn_type === 'l'">
          {{ 'LG CDN' }}
        </div>
        <div v-else-if="item.cdn_type === 'n'">
          {{ 'Nginx' }}
        </div> -->
        <div v-if="item.cdn_type === 'Tencent'">
          {{ 'Tencent' }}
        </div>
      </template>

      <template v-slot:item.testurl="{ item }">
        <router-link to="/cdn/info">
          <v-btn dark elevation="0" small @click="getInfo(item)">
            {{ $store.getters.t('정보') }}
          </v-btn>
        </router-link>


      </template>

    </v-data-table>

    <!--등록 btn-->
    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">

        <router-link to="/statistics">
          <TextButton :buttonText="$store.getters.t('통계')" class="mr-2" />
        </router-link>

        <!-- <router-link to="/cdn/create_wowzaserver"> -->
        <TextButton :buttonText="$store.getters.t('등록')" isPrimary @click="openModal" />
        <!-- <TextButton buttonText="등록" isPrimary/> -->
        <!-- </router-link> -->

        <AppDialog :value="modalOpen" @input="openModal = $event">
          <template v-slot:title>
            {{ $store.getters.t('CDN 등록') }}
          </template>
          <template v-slot:content>
            <AppInputAlert :message="message" :message-type="messageType" class="mb-5"></AppInputAlert>

            <h5 class="mb-2" style="color:black;">{{ $store.getters.t('Wowza Server') }}</h5>
            <v-combobox dense v-model="selServer" :items="wowzaServersItem" outlined color="black" />

            <h5 style="color:black;">{{ $store.getters.t('Type') }}</h5>
            <v-radio-group v-model="column" column style="height: 40px;">
              <v-radio label="Tencent" value="Tencent" class="mt-2" color="black" />
            </v-radio-group>
          </template>
          <template v-slot:actions>
            <TextButtonBlock :buttonText="$store.getters.t('닫기')" @click="closeModal" />
            <TextButtonBlock :buttonText="$store.getters.t('생성')" isPrimary :loading="isLoading" @click="createCdn" />
          </template>
        </AppDialog>
      </v-col>
    </v-row>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

  </div>
</template>

<script>
import IconButton from '@/components/ui/button/IconButton.vue';
//import TextButton from '@/components/ui/button/TextButton.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import SearchTextfield from '@/components/app/AppSearchField.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AppDialog from '@/components/app/AppDialog.vue';
import Input from '@/components/ui/form/FormInput.vue';
import AppInputAlert from '@/components/app/AppInputAlert.vue';
import CdnApi from "@/api/cdn/CdnApi";
import WowzaServerApi from "@/api/wowzaserver/WowzaServerApi";
import { mapState } from 'vuex';


export default {
  components: {
    TextButton,
    IconButton,
    SearchTextfield,
    AppSnackbar,
    AppDialog,
    TextButtonBlock,
    Input,
    AppInputAlert
  },
  data() {
    return {
      headers: [
        { text: 'ID', value: 'aws_cf_dtid', align: 'center', sortable: false },
        { text: 'CDN 도메인', value: 'cdn_cname', align: 'center', sortable: false },
        { text: 'CNAME', value: 'domain', align: 'center', sortable: false },
        { text: 'Status', value: 'status', align: 'center', sortable: false },
        { text: 'Last modified', value: 'created_at', align: 'center', sortable: false },
        { text: 'Type', value: 'cdn_type', align: 'center', sortable: false },
        { text: 'Client#', value: 'cms_name', align: 'center', sortable: false },
        { text: 'Tencent 계정', value: 'tencent_account', align: 'center', sortable: false },
        { text: '서비스 타입', value: 'service', align: 'center', sortable: false },
        { text: 'CDN 정보', value: 'testurl', align: 'center', sortable: false },
      ],
      cdnItem: [],
      selected: [],
      search: '',
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      modalOpen: false,
      wowzaServersItem: [],
      selServer: null,
      column: 'Tencent',
      isLoading: false,
      message: '',
      messageType: '',
    }
  },
  computed: {
    ...mapState('search', ['searchQuery']),
  },
  mounted() {
    this.cdnList();
    //this.wowzaServerList();
  },
  methods: {
    async cdnList() {
      try {
        this.loading = true;
        const response = await CdnApi.listApi();
        this.loading = false;
        this.cdnItem = response.cdn;
      } catch (error) {
        console.error('error', error);
      }
    },
    async cdnDelete() {

      if (this.selected.length > 0 && !this.selected.some(server => server.status === "Enabled")) {
        this.loading = true;
        const data = {
          serverIds: this.selected.map(server => server.id)
        };
        try {
          const response = await CdnApi.deleteApi(data);
          if (response.status === 200) {
            this.loading = false;
            this.selected = [];
            this.snackbarText = '삭제 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.cdnList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '삭제 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '삭제 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);
    },
    async cdnStatusOffChange() {

      if (this.selected.length > 0 && !this.selected.some(server => server.status === "Disabled")) {
        this.loading = true;

        const data = {
          ids: this.selected.map(server => server.id),
          status: "Disabled"
        };
        try {
          const response = await CdnApi.statusChangeApi(data);
          if (response.status === 200) {
            this.loading = false;
            this.selected = [];
            this.snackbarText = '변경 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.cdnList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '변경 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '변경 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);

    },
    async cdnStatusOnChange() {

      if (this.selected.length > 0 && !this.selected.some(server => server.status === "Enabled")) {
        this.loading = true;
        const data = {
          ids: this.selected.map(server => server.id),
          status: "Enabled"
        };
        try {
          const response = await CdnApi.statusChangeApi(data);
          if (response.status === 200) {
            this.loading = false;
            this.selected = [];
            this.snackbarText = '변경 성공';
            this.snackbarError = false;
            this.snackbar = true;
            this.cdnList();
          }
        } catch (error) {
          console.error("error", error);
          this.snackbarText = '변경 실패';
          this.snackbarError = true;
          this.snackbar = true;
        }
      } else {
        console.log('error');
        this.snackbarText = '변경 실패';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);

    },
    async refresh() {
      this.cdnList();
    },
    openModal() {
      this.wowzaServerList();
      this.modalOpen = true;
    },
    async wowzaServerList() {
      try {
        const response = await WowzaServerApi.listForCdnCreateApi();
        this.wowzaServersItem = response.wowzaServers;

      } catch (error) {
        console.error('error', error);
      }
    },
    resetForm() {
      this.name = '';
      this.port = '';
      this.ip = '';
      this.serviceType = '';
    },
    closeModal() {
      this.resetForm();
      this.modalOpen = false;
    },
    async createCdn() {
      this.isLoading = true;
      const word = this.splitWord(this.selServer);
      const data = {
        wowzaServersItem: word,
        column: this.column,
        ip: window.location.protocol + '//' + window.location.hostname,
      }
      const response = await CdnApi.addApi(data);
      if (response.status === 200) {
        this.isLoading = false;
        this.closeModal();
        this.cdnList();
      }
    },
    splitWord(word) {
      const words = word.split(' ');
      
      if (words.length > 0) {
        this.word = words[0];
      }
      else {
        this.firstWord = '';
      }
      return this.word;
    }



  },
}
</script>

<style>
.status-container {
  display: inline-flex;
  align-items: center;
}

.status-icon {
  margin-right: 4px;
  /* 조정 가능한 마진 값 */
}

.in-progress .status-text {
  font-style: italic;
  /* InProgress 텍스트를 이탤릭체로 표시 */
}
</style>